export default __webpack_public_path__ + "static/media/DSC05964.9f27fe18.jpg";